<script>
export default {
  forms: [
    {
      grace_period_days: {
        label: 'Période de grâce en cas d\'échec de paiement (en jours)',
        type: 'number',
        column: 'is-12',
        inputAttrs: {
          min: 0,
          max: 30,
          step: 1,
        },
        tooltip: `
          Nombre de jours pendant lesquels les abonnés conservent l'accès après un échec de paiement. 
          Défini sur 0 pour désactiver la période de grâce.
        `,
        tooltipAttrs: {
          multilined: true,
        },
      },
    },
  ],
  created() {
    this.hydrate();
  },
  data() {
    return {
      isLoading: {
        0: false,
      },
      membership: {
        grace_period_days: 0,
      },
    };
  },
  computed: {
    currentMembership() {
      return this.$store.state.memberships.current;
    },
  },

  methods: {
    hydrate() {
      Object.keys(this.membership)
        .forEach((key) => {
          if (key === 'grace_period_days') {
            this.membership[key] = this.currentMembership[key] || 0;
          } else {
            this.membership[key] = this.currentMembership[key];
          }
        });
    },
    handle(form, fk) {
      const membershipData = {};

      Object.keys(form)
        .forEach((key) => (membershipData[key] = this.membership[key]));

      this.isLoading[fk] = true;
      this.$store.dispatch('memberships/update', { uuid: this.currentMembership.uuid, membershipData, isCurrent: true })
        .then(() => this.$showMessage.success())
        .finally(() => (this.isLoading[fk] = false));
    },
  },
};
</script>

<template>
  <AppFeatureWrapper>
    <template #title>
      Paiements et échecs
    </template>
    <template #content>
      <p>
        Configurez la gestion des échecs de paiement et les périodes de grâce pour vos abonnés.
      </p>
    </template>

    <template #form>
      <form v-for="(form, fk) in $options.forms" :key="(form, fk)" ref="form" class="box"
        @submit.prevent="dataIsValid(isLoading[fk]) && handle(form, fk)">
        <div class="columns is-multiline">
          <div v-for="(field, key) in form"
            v-show="field.ifModelName == null || membership[field.ifModelName] == field.ifModelValue" :key="key"
            class="column" :class="field.column">
            <BaseField v-model="membership[key]" :field="field" />
          </div>
        </div>

        <b-field class="has-text-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading[fk]">
            Mettre à jour
          </b-button>
        </b-field>
      </form>
    </template>
  </AppFeatureWrapper>
</template>
